import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useMemo } from 'react';

import type { User } from '~/contexts/UserAuthProvider';

// Helpers
const isQAUser = (userEmail: string) =>
  userEmail.startsWith('test') && userEmail.endsWith('@finleycms.com');

// Exports
export const useIdentifyLDUser = () => {
  const ldClient = useLDClient();
  return useMemo(
    () => ({
      identifyLDUser: (user: User) => {
        if (ldClient) {
          ldClient.identify({
            kind: 'user',
            key: user.id,
            orgSlug: user.organization.slug,
            roleType: user.roleType,
            isInternalFinleyUser: isQAUser(user.email),
          });
        }
      },
    }),
    [ldClient],
  );
};
